import { environment } from './environment';

const ENV = import.meta.env.APP_ENV || 'demo';

if (!environment[ENV]) {
  throw new Error(
    `Environment "${ENV}" not found. Available environments: ${Object.keys(environment).join(', ')}`
  );
}

export const currentEnv = environment[ENV];
